module.exports = __webpack_public_path__ + "static/media/plant-care.2a69766a.jpg";